import React from 'react';

export function StepEditLabel() {
  return (
    <>
      Cílová provozovna - <b>Údaje sloučení</b>
    </>
  );
}
